import * as React from "react";
import { RouteComponentProps } from "react-router";
import CollaboratorAnalyticsSection from "../components/users/CollaboratorAnalyticsSection";
import CollaboratorDocumentsSection from "../components/users/CollaboratorDocumentsSection";
import CollaboratorFollowUpsSection from "../components/users/CollaboratorFollowUpsSection";
import CollaboratorHeader from "../components/users/CollaboratorHeader";
import CollaboratorNotesSection from "../components/users/CollaboratorNotesSection";
import { UserGroups } from "../components/users/UserGroups";
import {
  Container,
  EmptyState,
  Link,
  ScreenContainer,
} from "../components/wombat-ui";
import useGetUserFull from "../graphql/hooks/queries/useGetUserFull";
import useTranslations from "../hooks/useTranslations";
import useViewer from "../hooks/useViewer";

type UserProfileScreenProps = RouteComponentProps<{ id: string }>;

const UserProfileScreen: React.FC<UserProfileScreenProps> = ({ match }) => {
  const { data, loading, error } = useGetUserFull({
    variables: { id: match.params.id },
  });

  const t = useTranslations();
  const user = data?.user;

  const viewer = useViewer();

  return (
    <ScreenContainer
      loading={loading}
      error={
        error ? (
          <EmptyState
            title={t("network.unauthorized") as string}
            action={
              <Link to="/" variant="button">
                {t("network.backToHome")}
              </Link>
            }
          />
        ) : undefined
      }
    >
      {user && (
        <>
          <CollaboratorHeader user={user} />
          <Container className="px-4 sm:px-6 lg:px-24">
            <div className="grid max-w-6xl grid-cols-12 gap-12 pb-12 mx-auto">
              {
                <div className="col-span-8">
                  {viewer.isCapableOfReadingUserNotes && (
                    <CollaboratorNotesSection user={user} />
                  )}
                  <CollaboratorAnalyticsSection user={user} />
                  <CollaboratorFollowUpsSection user={user} />
                  <CollaboratorDocumentsSection user={user} vertical />
                </div>
              }
              <div className="col-span-4">
                <UserGroups user={user} />
              </div>
            </div>
          </Container>
        </>
      )}
    </ScreenContainer>
  );
};

export default UserProfileScreen;
